import { createFileRoute } from "@tanstack/react-router";

import { ReceiptFormPage } from "../../../../features/purchasing/receipt-form-page";

export const Route = createFileRoute("/_app/purchasing/receipts/new")({ component: ReceiptFormPage });
